import { Item } from '../Card';
import { Body1, Caption } from '@xo-union/tk-ui-typography';
import React from 'react';

import { EmbedItemsFragment } from '../../generated/graphql';
import { embedItemRoute } from '../../helpers/routes';
import { PageItemLink } from '../PageItemLink';
import { ItemProps } from './common';
import styles from './index.scss';

const Embed: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const embed = item as EmbedItemsFragment;

  return (
    <PageItemLink
      to={embedItemRoute(page.id, embed.id, preview)}
      page={page}
      pageItem={item}
      data-testid={`embed-item-${embed.id}`}
    >
      <Item className={className} {...dragProps}>
        <div className={styles.container}>
          <Caption>Playlist</Caption>
          <Body1 className={styles.uppercase}>{embed.title ? embed.title : `${embed.mediaService} Playlist`}</Body1>
        </div>
      </Item>
    </PageItemLink>
  );
};

export default Embed;
